import axios from "./axios";

export const getCities = () => axios.get().get(`/cities`)
